<template>
  <v-app>
      <router-view style="background-color: #434445;"/>
  </v-app>
</template>

<style>
.app {
  height: 100vh;
  width: 100vw;
  font-family: Arial, Helvetica, sans-serif;
}

</style>

<script>
export default {
  name: 'App'
}
</script>